'use client';
import { jsx } from 'react/jsx-runtime';
import { createContext, useContext } from 'react';
import { useServerTranslate } from '../services/serverTranslationService.js';

const TranslationContext = createContext({});
const useTranslation = () => {
    const { translations, verbose } = useContext(TranslationContext);
    const translate = useServerTranslate(translations, verbose);
    return { t: translate };
};
const TranslationContextProvider = ({ translations, verbose, children }) => {
    return (jsx(TranslationContext.Provider, { value: { translations, verbose }, children: children }));
};

export { TranslationContextProvider, useTranslation };
//# sourceMappingURL=use-translation.js.map
